<template>
<!-- enter mobile step -->
		<div class="modal fade" id="MobileModal" tabindex="-1" role="dialog">
			<div class="modal-dialog">
				<!-- Modal content-->
				<div class="modal-content">
					   <button type="button" style="display:none" class="btn-close" data-bs-dismiss="modal" id="mobileModalCloseBTN"></button>
						<div class="modal-body dir-rtl">
                            <div class="col-md-12 ">
                                <div >
                                    <h3 class="agileinfo_sign" style="display: inline-block">ثبت نام</h3>
                                    <button type="button" class="btn-close" data-bs-dismiss="modal" style="float:left"></button>
                                </div>
                                <h4 class="agileinfo_sign mt-2 pr-1" style="font-size:16px;line-height:1.5">لطفا شماره موبایلتان را وارد کنید تا کد فعالسازی را برایتان ارسال کنیم :</h4>
                                <div class="form-group mt-3">
                                    <input class="form-control dir-rtl" v-model="telNumber" style="height: 49px;opacity: .8;font-size:1.1em" type="tel"  maxlength="11" placeholder="مثلا ۰۹۱۵۱۲۳۴۵۶۷" >
                                    <span style="color:red">{{validMessage}}</span>
                                    <button class="btn btn-success mt-3 valid-btn" @click="validNumber">ادامه</button>
                                </div>
                            </div>
					    </div>
                        <button class="border-0 bg-transparent my-2" style="width: 100%;color:rgb(22 93 93);font-size: .93em;" @click="goEntry">اگر قبلا ثبت نام کرده اید <span class="text-primary">اینجا</span> کلیک کنید</button>
				</div>
			</div>
		</div>
<validation-popup :code="code" :userMobile="telNumber" />
<button type="button" id="validationModalBTN" data-bs-toggle="modal" data-bs-target="#validationModal" style="display:none"></button>
</template>

<script setup>
import ValidationPopup from '../popup/validation.vue'
import {ref,watch} from "vue";
import axios from 'axios';
import { convertToEnglish, convertToPersian } from '@/composables/digits.js';
let telNumber = ref();
let validMessage = ref();
let code = ref();

watch(telNumber,() => {
    telNumber.value = convertToPersian(telNumber.value)
})
function validNumber(){

    if(telNumber.value && parseInt(telNumber.value.length ) == 11 && convertToEnglish(telNumber.value.slice(0,2)) == '09'){
        validMessage.value = '';
        const formData = new FormData();
        formData.append('number', convertToEnglish(telNumber.value));
        axios.post('https://radap.ir/Backend/api/section/follow/valide.php',formData)
        .then((res) => {
            if(res.data  == 'exist'){
                validMessage.value = 'شما قبلا ثبت نام کرده اید';
                setTimeout(goEntry,2000)
            }else{
                document.querySelector('#validationModalBTN').click();
                code.value = res.data - 876;
            }
        })
    }else{
        validMessage.value = 'شماره موبایل اشتباه است';
    }
}
function goEntry(){
    document.querySelector('#mobileModalCloseBTN').click()
    document.querySelector('#loginsModalBTN').click()
}
</script>

<style scoped>
.dir-rtl{
	text-align: right;
	direction: rtl;
}
.valid-btn{
    width: 100%;
     border:none
}
</style>